// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bey_a bht_bk bht_bl bht_bo","SwipeLeftToClose--animating":"bey_b"};